export default class CommunicationToolCollectionController {
  /* @ngInject */
  constructor(CommunicationToolService, RouterService, InfiniteTriggerService) {
    this.routerService = RouterService;
    this.infiniteTriggerService = InfiniteTriggerService;
    this.communicationToolService = CommunicationToolService;
  }

  $onInit() {
    this.collectionId = this.routerService.state.params.collectionId;
    this.categoryId = this.routerService.state.params.categoryId;
    this.getItems({page: 1}).then((newItems) => {
      this.items = newItems.items;
      const collection = this.items[0] ? this.items[0].collection : {};
      this.breadcrumbs = [{label: 'Communication Tools'}, collection];
      this.updatePagination(newItems);
    });
  }

  getItems(params) {
    return this.communicationToolService.items(this.collectionId, params);
  }

  updateItems() {
    if (this.httpUpdateItemsIsPending) {
      return;
    }
    this.httpUpdateItemsIsPending = true;
    this.getItems({page: this.currentPage += 1}).then((newItems) => {
      this.httpUpdateItemsIsPending = false;
      this.items = [...this.items, ...newItems.items];
      this.updatePagination(newItems);
    });
  }

  updatePagination({total, page, perPage}) {
    this.totalProducts = total;
    this.currentPage = page;
    this.perPage = perPage;
  }

  hasMoreItems() {
    return this.infiniteTriggerService.canLoadMoreItems({
      totalItems: this.totalProducts,
      itemsPerPage: this.perPage,
      currentPage: this.currentPage,
    });
  }

  $onDestroy() {
  }
}



// WEBPACK FOOTER //
// ./src/app/communication-tool/communication-tool-collection/communication-tool-collection.controller.js